// Shared look for the login / signup cards. The cards are white, so this
// re-exports the darkened tone — the bright accent is 1.8:1 on white.
export { ACCENT_ON_LIGHT as ACCENT } from "../../theme/accent";

export const INPUT_CLASS =
  "w-full bg-black/[0.03] border border-black/10 rounded-md px-4 py-3.5 " +
  "font-body text-[#111113] placeholder:text-black/40 " +
  "focus:outline-none focus:border-accent-on-light/60 transition-colors duration-300";

export const SUBMIT_CLASS =
  "group w-full bg-accent !border !border-accent " +
  "px-8 py-3.5 rounded-md font-headline font-bold !text-accent-ink " +
  "hover:bg-accent-hover hover:!border-accent-hover " +
  "transition-all duration-300 active:scale-95 flex items-center !justify-center gap-2";

export const ERROR_CLASS = "font-body text-[13px] text-[#d92d20] mt-1.5 mb-0";
